import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs } from 'material-ui/Tabs';

import RecordABCData from './components/RecordABCData/RecordABCData';
import RecordDuration from './components/RecordDuration/RecordDuration';
import RecordFrequency from './components/RecordFrequency/RecordFrequency';
import RecordInterval from './components/RecordInterval/RecordInterval';
import RecordMomentary from './components/RecordMomentary/RecordMomentary';
import RecordRate from './components/RecordRate/RecordRate';

import { PatientRecordMomentaryCustomTimeAction, PatientRecordIntervalCustomeTimeAction } from './actions/BehaviourDataActions'

const innerTabStyles = {
    default_tab: {
        height: '40px',
        fontSize: '14px',
        backgroundColor: '#fff',
        color: 'rgba(0, 0, 0, 0.60)',
        border: '1px solid #ddd',
    },
    active_tab: {
        height: '37px',
        color: 'rgba(0, 0, 0, 0.80)',
        border: '1px solid #ddd',
        backgroundColor: '#fff',
    },
};

class BehaviourData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patientId: props.patientId ? props.patientId : 0,
            innerActiveTab: '0',
        }
    }

    setInnerActive = (value) => {
        if (value === this.state.innerActiveTab) {
            return false;
        }
        this.setState({ innerActiveTab: value });
    }

    
    componentWillMount = () => {
        this.props.PatientRecordIntervalCustomeTimeAction(this.state.patientId);
        this.props.PatientRecordMomentaryCustomTimeAction(this.state.patientId);
    }
    

    renderBehaviorDatatTabs = () => {
        let component = null;
        innerTabStyles.tab = [];
        innerTabStyles.tab[0] = innerTabStyles.default_tab;
        innerTabStyles.tab[1] = innerTabStyles.default_tab;
        innerTabStyles.tab[2] = innerTabStyles.default_tab;
        innerTabStyles.tab[3] = innerTabStyles.default_tab;
        innerTabStyles.tab[4] = innerTabStyles.default_tab;
        innerTabStyles.tab[5] = innerTabStyles.default_tab;
        innerTabStyles.tab[this.state.innerActiveTab] = innerTabStyles.active_tab;
        switch (this.state.innerActiveTab) {
            case '0':
                component = (<RecordABCData patientId={this.state.patientId}  
                            addPermissionBehavior = {this.props.addPermissionBehavior}
                            updatePermissionBehavior = {this.props.updatePermissionBehavior}
                            deletePermissionBehavior =  {this.props.deletePermissionBehavior}
                            />);
                break;
            case '1':
                component = (<RecordFrequency patientId={this.state.patientId} 
                            addPermissionBehavior = {this.props.addPermissionBehavior}
                            updatePermissionBehavior = {this.props.updatePermissionBehavior}
                            deletePermissionBehavior =  {this.props.deletePermissionBehavior}
                            />);
                break;
            case '2':
                component = (<RecordDuration patientId={this.state.patientId} 
                            addPermissionBehavior = {this.props.addPermissionBehavior}
                            updatePermissionBehavior = {this.props.updatePermissionBehavior}
                            deletePermissionBehavior =  {this.props.deletePermissionBehavior}
                            />);
                break;
            case '3':
                component = (<RecordRate patientId={this.state.patientId} 
                            addPermissionBehavior = {this.props.addPermissionBehavior}
                            updatePermissionBehavior = {this.props.updatePermissionBehavior}
                            deletePermissionBehavior =  {this.props.deletePermissionBehavior}
                            />);
                break;
            case '4':
                component = (<RecordInterval patientId={this.state.patientId} 
                            addPermissionBehavior = {this.props.addPermissionBehavior}
                            updatePermissionBehavior = {this.props.updatePermissionBehavior}
                            deletePermissionBehavior =  {this.props.deletePermissionBehavior}
                            />);
                break;
            case '5':
                component = (<RecordMomentary patientId={this.state.patientId} 
                            addPermissionBehavior = {this.props.addPermissionBehavior}
                            updatePermissionBehavior = {this.props.updatePermissionBehavior}
                            deletePermissionBehavior =  {this.props.deletePermissionBehavior}
                            />);
                break;
            default:
                component = (<RecordABCData patientId={this.state.patientId} 
                            addPermissionBehavior = {this.props.addPermissionBehavior}
                            updatePermissionBehavior = {this.props.updatePermissionBehavior}
                            deletePermissionBehavior =  {this.props.deletePermissionBehavior}
                            />);
                break;
        }
        return (
            <div className="readmin-panel">
                <div className="panel-body">
                    <div>
                        <Tabs className="custom_tabs secondary_tab">
                            <Tab className="customtab" style={innerTabStyles.tab[0]}
                                onClick={(e) => this.setInnerActive('0')}
                                value={0}
                                label={<font>ABC Data</font>}>
                            </Tab>
                            <Tab className="customtab" style={innerTabStyles.tab[1]}
                                onClick={(e) => this.setInnerActive('1')}
                                value={1}
                                label={<font>Frequency</font>}>
                            </Tab>
                            <Tab className="customtab" style={innerTabStyles.tab[2]}
                                onClick={(e) => this.setInnerActive('2')}
                                value={1}
                                label={<font>Duration</font>}>
                            </Tab>
                            <Tab className="customtab" style={innerTabStyles.tab[3]}
                                onClick={(e) => this.setInnerActive('3')}
                                value={1}
                                label={<font>Rate</font>}>
                            </Tab>
                            <Tab className="customtab" style={innerTabStyles.tab[4]}
                                onClick={(e) => this.setInnerActive('4')}
                                value={1}
                                label={<font>Partial Interval</font>}>
                            </Tab>
                            <Tab className="customtab" style={innerTabStyles.tab[5]}
                                onClick={(e) => this.setInnerActive('5')}
                                value={1}
                                label={<font>Momentary Time Sampling</font>}>
                            </Tab>
                        </Tabs>
                        {component}
                    </div>
                </div>
            </div>
        );
    }

    render() {

        return (
            <div>
                {this.renderBehaviorDatatTabs()}
            </div>
        )
    }
}

export default connect(null, {PatientRecordMomentaryCustomTimeAction, PatientRecordIntervalCustomeTimeAction})(BehaviourData);


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/index.js